import { Input } from "antd";
import styles from "./index.module.less";
import ArrowIcon from "@/assets/imgs/arrow_right.svg";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { useClickAway } from "ahooks";
import { options, Option } from "./options";
import MobileModal from "@/components/MobileModal";

const CitySelector = ({
  value = [],
  onChange,
}: {
  value?: string[];
  onChange?: (value: string[]) => void;
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<any>(null);
  const ref1 = useRef<any>(null);
  useClickAway(() => {
    setOpen(false);
  }, [ref, ref1]);
  const [selectedProvince, setSelectedProvince] = useState<string | null>();
  const [cityOptions, setCityOptions] = useState<Option[]>([]);
  useEffect(() => {
    // 滚动到选中的省份
    if (open && ref.current) {
      const selectedIndex = options.findIndex(
        (option) => option.label === selectedProvince
      );
      if (selectedIndex !== -1) {
        const optionElements = ref.current.querySelectorAll(
          `.${styles.option}`
        );
        if (optionElements[selectedIndex]) {
          optionElements[selectedIndex].scrollIntoView({
            behavior: "smooth",
            // block: "center",
          });
        }
        // 滚动到选中的城市
        if (value[1]) {
          const cityIndex = (options[selectedIndex].children || []).findIndex(
            (option) => option.label === value[1]
          );
          if (cityIndex !== -1) {
            const cityElements = ref.current.querySelectorAll(
              `.${styles.subOptions} .${styles.option}`
            );
            if (cityElements[cityIndex]) {
              cityElements[cityIndex].scrollIntoView({
                behavior: "smooth",
                // block: "center",
              });
            }
          }
        }
      }
    }
  }, [value, open]);

  return (
    <div className={styles.citySelector}>
      <div
        className={styles.cityInput}
        onClick={() => setOpen(true)}
        ref={ref1}
      >
        <Input
          placeholder="请输入您的城市"
          className={styles.input}
          readOnly
          value={value.join("/")}
        />
        <div className={styles.cityIcon}>
          <img src={ArrowIcon} />
        </div>
      </div>
      <MobileModal open={open} onClose={() => setOpen(false)} title="选择城市">
        <div
          className={classNames(styles.cityDropdown, { [styles.open]: true })}
          ref={ref}
        >
          <div className={styles.options}>
            <div className={styles.optionsInner}>
              {options.map((option) => (
                <div
                  key={option.value}
                  className={classNames(styles.option, {
                    [styles.selectedOption]: selectedProvince === option.label,
                  })}
                  onClick={() => {
                    setSelectedProvince(option.label);
                    setCityOptions(option.children || []);
                  }}
                >
                  <div className={styles.optionLabel}>{option.label}</div>
                  {option.children && (
                    <div className={styles.arrow}>
                      <img src={ArrowIcon} />
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className={styles.subOptions}>
              {cityOptions.map((option) => (
                <div
                  key={option.value}
                  className={classNames(styles.option, {
                    [styles.selectedOption]: value[1] === option.label,
                  })}
                  onClick={() => {
                    if (!selectedProvince) return;
                    onChange?.([selectedProvince, option.label]);
                    setOpen(false);
                  }}
                >
                  {option.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </MobileModal>
    </div>
  );
};
export default CitySelector;
